<template>
  <MatchMedia v-slot="{ matches: isDesktop }" device="desktop">
    <div v-if="available" class="col__container">
      <BaseText
        v-if="!isDesktop"
        size="md"
        :color="NebraskaColors.textSecondary"
      >
        {{ labelMobile }}
      </BaseText>
      <BaseText :size="isDesktop ? 'sm' : 'md'">
        {{ value }}
      </BaseText>
    </div>
  </MatchMedia>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseText, InputMoney } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { MatchMedia } from '@/modules/common/components/MatchMedia';

@Component({
  components: { BaseText, MatchMedia, InputMoney }
})
export default class ProductToWithdrawCol extends Vue {
  public readonly NebraskaColors = NebraskaColors;

  @Prop({ type: String, required: false, default: '' })
  readonly labelMobile!: string;

  @Prop({ type: String, required: true })
  readonly value!: string;

  @Prop({ type: Boolean, required: true, default: true })
  readonly available!: boolean;
}
</script>
<style lang="less" scoped>
.col {
  &__container {
    .to-md({ display: flex; justify-content: space-between; padding-top: @size-spacing-x300 });
  }
}
</style>
